/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";

export class SegmentSubcoOfferRequestViewModel extends JSONable {

  uuid: string | undefined = undefined;

  shipmentGroupUuid: string | undefined = undefined;

  offerRequestUuid: string | undefined = undefined;

  serviceProviderUuid: string | undefined = undefined;

  serviceProviderName: string | undefined = undefined;

  offerRequestDate: string | undefined = undefined;

  deadline: string | undefined = undefined;

  offerRequestStatus: string | undefined = undefined;

}
